import { useState } from "react";
import API from "../../lib/api";
import PdfBrandingDialog, { downloadBlob } from "../hs/PdfBrandingDialog";

/** HSE PDFs use the same per-download branding dialog as RAMS/permits. `pending` = { url, filename, clientId?, title, body? }.
 *  Use default → GET url (or POST body without branding); Download branded → POST url with the dialog's branding merged in. */
export function useBrandedPdf() {
  const [pending, setPending] = useState(null);
  const open = (opts) => setPending(opts);
  const run = async (branding) => {
    if (!pending) return;
    const { url, filename, body, onDone } = pending;
    const resp = branding || body
      ? await API.post(url, { ...(body || {}), ...(branding ? { branding, save_for_client: !!branding.save_for_client } : {}) }, { responseType: "blob" })
      : await API.get(url, { responseType: "blob" });
    downloadBlob(resp.data, typeof filename === "function" ? filename(resp) : filename);
    onDone?.(resp);
  };
  const dialog = (
    <PdfBrandingDialog open={!!pending} onOpenChange={(o) => { if (!o) setPending(null); }} clientId={pending?.clientId} onDownload={run} hseLetterhead={pending?.hse !== false}
      title={pending?.title || "PDF branding"} hint={pending?.clientId ? undefined : pending?.hse === false ? "Applies to this download only." : "Applies to this download only unless you tick 'Save as my HSE letterhead'."}
      description={pending?.description || "Put your own logo, name, tagline, footer and accent colour on this PDF, or use your default company branding."} />
  );
  return { openBranded: open, brandingDialog: dialog };
}
